const SvgItAutomation2 = (props) => (
  <>
    <path fill={props.p20} d="M192.5 0v192l-96-96 96-96z" />
    <circle cx={96.5} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={16} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={16} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={32} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={32} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={32} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={48} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={48} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={48} r={1} fill="#001d6c" />
    <circle cx={48.5} cy={48} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={64} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={64} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={64} r={1} fill="#001d6c" />
    <circle cx={48.5} cy={64} r={1} fill="#001d6c" />
    <circle cx={32.5} cy={64} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={80} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={80} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={80} r={1} fill="#001d6c" />
    <circle cx={48.5} cy={80} r={1} fill="#001d6c" />
    <circle cx={32.5} cy={80} r={1} fill="#001d6c" />
    <circle cx={16.5} cy={80} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={96} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={96} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={96} r={1} fill="#001d6c" />
    <circle cx={48.5} cy={96} r={1} fill="#001d6c" />
    <circle cx={32.5} cy={96} r={1} fill="#001d6c" />
    <circle cx={16.5} cy={96} r={1} fill="#001d6c" />
    <circle cx={0.5} cy={96} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={112} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={112} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={112} r={1} fill="#001d6c" />
    <circle cx={48.5} cy={112} r={1} fill="#001d6c" />
    <circle cx={32.5} cy={112} r={1} fill="#001d6c" />
    <circle cx={16.5} cy={112} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={128} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={128} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={128} r={1} fill="#001d6c" />
    <circle cx={48.5} cy={128} r={1} fill="#001d6c" />
    <circle cx={32.5} cy={128} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={144} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={144} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={144} r={1} fill="#001d6c" />
    <circle cx={48.5} cy={144} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={160} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={160} r={1} fill="#001d6c" />
    <circle cx={64.5} cy={160} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={176} r={1} fill="#001d6c" />
    <circle cx={80.5} cy={176} r={1} fill="#001d6c" />
    <circle cx={96.5} cy={192} r={1} fill="#001d6c" />
  </>
);

export default SvgItAutomation2;
